import React from 'react';
import rawToReact from 'Utils/bbcode/RawToReact';

import SvgIcon from 'Components/svg/SvgIcon';
import Date from 'Components/common/dateComponent';

import { resetOverlay, showLoginModal, showConfirmModal } from 'Actions/UiActions';
import { updateFollowing } from 'Actions/ForumviewActions';
import { trackGAEvent } from 'Actions/adsActions';

class ForumComponent extends React.Component {
	subscribeForum = ( event ) => {
		let userState = this.props.ustate, isSub, subType;

		event.stopPropagation(); // stop here

		if( userState.id ) {
			if (typeof this.props.forum !== 'undefined' ) {
				isSub = !!this.props.forum.isSubscribed;
				subType = 'forum';
			} else {
				isSub = !!this.props.thread.isSubscribed;
				subType = 'topic';
			}

			if( isSub  ) {
				this.props.dispatch( showConfirmModal( 'Unsubscribe', `Would you like to unsubscribe from this ${subType}?`, () => this.props.dispatch( updateFollowing(this.props) ) ) );
			} else {
				this.props.dispatch( updateFollowing(this.props) );
			}

			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'followingForum', 'uiAction', 'tap' ) );

		} else {
			// for guests show the login modal
			this.props.dispatch( resetOverlay() );
			this.props.dispatch( showLoginModal() );
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'followForum', 'userAction', 'loginPrompt' ) );
		}
	};

	render() {
		const { title, topicCounter, lastPost, isRead, isSubscribed } = this.props.forum;

		return (
			<div className={ `forum${ isRead ? '' : ' indicator' }${ isSubscribed ? ' subscribed' : '' }` }>
				<div className="title">
					{ rawToReact(title) }
				</div>
				<div className="subscribe" onClick={ this.subscribeForum } >
					<SvgIcon size="20px" icon="subscribe"/>
				</div>
				<div className="stats">
					<div className='left-stats'>
						<SvgIcon size="12px" icon="forum" />
						{ topicCounter.toLocaleString() } topics
					</div>
					<Date timestamp={ lastPost } icon={ true } />
				</div>
			</div>
		);
	}
}

export default ForumComponent;


// WEBPACK FOOTER //
// ./src/components/forums/ForumComponent.js